import { useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

const KEY = "rw-cookie-consent";

export function getConsent() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}

export default function CookieConsent() {
  const { t } = useI18n();
  const [choice, setChoice] = useState(() => getConsent());

  const decide = (value) => {
    const record = { choice: value, at: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(record));
    setChoice(record);
  };

  if (choice) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] border-t border-[#1F293D] bg-[#0B0E14]/95 backdrop-blur-xl" data-testid="cookie-banner">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:px-6 lg:px-8">
        <p className="flex-1 text-xs leading-relaxed text-slate-400">
          <span className="font-bold text-slate-200">{t("cookies.title")} — </span>
          {t("cookies.text")}{" "}
          <Link to="/legal/cookies" target="_blank" rel="noopener noreferrer" className="text-[#00F0FF] underline underline-offset-2">{t("footer.cookies")}</Link>
        </p>
        <div className="flex gap-2">
          <button
            onClick={() => decide("refused")}
            data-testid="cookie-refuse-button"
            className="rounded-md border border-[#1F293D] px-4 py-2 font-mono2 text-[11px] uppercase tracking-wider text-slate-300 transition-colors hover:border-red-500/50 hover:text-red-400"
          >
            {t("cookies.refuse")}
          </button>
          <button
            onClick={() => decide("accepted")}
            data-testid="cookie-accept-button"
            className="rounded-md border border-[#1F293D] px-4 py-2 font-mono2 text-[11px] uppercase tracking-wider text-slate-300 transition-colors hover:border-[#00FF87]/50 hover:text-[#00FF87]"
          >
            {t("cookies.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
